import { library, dom } from "@fortawesome/fontawesome-svg-core";

import {
    faAngleRight,
    faPhone,
    faPhoneFlip,
    faSearch,
    faXmark,
    faCaretDown
} from "@fortawesome/pro-solid-svg-icons";

import {
    faFacebook,
    faInstagram,
    faYoutube,
} from "@fortawesome/free-brands-svg-icons";

library.add(
    faAngleRight,
    faPhone,
    faPhoneFlip,
    faSearch,
    faFacebook,
    faInstagram,
    faXmark,
    faCaretDown,
    faYoutube
);

dom.watch();
